// extracted by mini-css-extract-plugin
module.exports = {"MerchantBlogEntries":"MerchantBlogEntries_MerchantBlogEntries__fGQlw"};